import React from "react";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";
import { useSelector } from "react-redux";

const PartialRenderRoute = (props) => {
  const { Component } = props;

  const navigate = useNavigate();

  const { user, isAuth } = useSelector((state) => state.auth);

  useEffect(() => {
    function checkLogin() {
      if (
        !window.isNative &&
        (!isAuth || user == null || user.type !== "user")
      ) {
        navigate("/login", { replace: true });
      }
    }
    checkLogin();
  }, [navigate]);

  return <Component />;
};

export default PartialRenderRoute;
